var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcoHeart = function SvgIcoHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ico-heart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 165",
    fill: "#35272a",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 707",
    clipPath: "url(#ico-heart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 84",
    d: "M12 22a1 1 0 0 1-.7-.289l-7.5-7.425A6 6 0 0 1 12 5.53a6 6 0 0 1 8.2 8.761c-.022.02-.043.041-.066.059L12.7 21.711A1 1 0 0 1 12 22m-6.794-9.137L12 19.593l6.8-6.732c.021-.019.042-.039.064-.057a4.1 4.1 0 0 0 .333-.388A4 4 0 1 0 12.8 7.607a1 1 0 0 1-.8.4 1 1 0 0 1-.8-.4 4 4 0 1 0-6 5.252l.008.008",
    fill: "#35272a"
  }))));
};

export default SvgIcoHeart;